"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportWebSocketFactory = void 0;
var apollo_link_ws_1 = require("apollo-link-ws");
var links_1 = require("./links");
var TransportFactory_1 = require("./TransportFactory");
var TransportWebSocketFactory = /** @class */ (function (_super) {
    __extends(TransportWebSocketFactory, _super);
    function TransportWebSocketFactory(_linkBuilderFactory, opts, _subscriptionClientFactory) {
        var _this = _super.call(this, _linkBuilderFactory, opts) || this;
        _this._subscriptionClientFactory = _subscriptionClientFactory;
        return _this;
    }
    TransportWebSocketFactory.prototype.make = function () {
        var builder = this.getBuilder();
        var _a = this.opts, token = _a.token, uri = _a.uri, webSocketClientOptions = _a.webSocketClientOptions;
        var subscriptionClient = this._subscriptionClientFactory.make({
            headers: this.createHeaders(),
            token: token,
            uri: uri,
            webSocketClientOptions: webSocketClientOptions,
        });
        var link = builder
            .addLink(links_1.filterUnionLink)
            .addLink(links_1.wsNormalizationLink)
            .addLink(new apollo_link_ws_1.WebSocketLink(subscriptionClient))
            .build();
        return link;
    };
    return TransportWebSocketFactory;
}(TransportFactory_1.TransportFactory));
exports.TransportWebSocketFactory = TransportWebSocketFactory;
//# sourceMappingURL=TransportWebSocketFactory.js.map